import type { ReactElement, ReactNode } from 'react';
import { Tooltip } from '@mui/material';

interface CustomTooltipProps {
  children: ReactElement;
  open: boolean;
  onClose: () => void;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  content: NonNullable<ReactNode>;
}

export const CustomTooltip = ({
  children,
  open,
  onClose,
  placement = 'top',
  content,
}: CustomTooltipProps) => {
  return (
    <Tooltip
      placement={placement}
      disableTouchListener
      disableFocusListener
      disableHoverListener
      open={open}
      onClose={onClose}
      arrow
      componentsProps={{
        tooltip: {
          style: {
            padding: 0,
            boxShadow: 'none',
            backgroundColor: 'transparent',
            maxWidth: 'none',
          },
        },
      }}
      PopperProps={{
        modifiers: [
          {
            name: 'preventOverflow',
            enabled: true,
            options: {
              boundary: 'viewport',
              padding: 8,
            },
          },
          {
            name: 'flip',
            enabled: true,
            options: {
              fallbackPlacements: ['bottom', 'top', 'right', 'left'],
              padding: 8,
            },
          },
        ],
      }}
      title={content}
    >
      {children}
    </Tooltip>
  );
};
